module.exports = __webpack_public_path__ + "static/media/hurtig.04fedd48.m4a";